export const GET_AGENTS = 'GET_AGENTS';
export const SET_AGENTS = 'SET_AGENTS';
export const GET_TEAM_SLIDER_AGENTS = 'GET_TEAM_SLIDER_AGENTS';
export const SET_FORMLISTSTATE = 'SET_FORMLISTSTATE';
export const GET_FORMLISTSTATE = 'GET_FORMLISTSTATE';

export const GET_FORMREQUIRED = 'GET_FORMREQUIRED';
